import React from 'react';

type SvglogoutProps = React.SVGProps<SVGSVGElement>;

const Svglogout: React.FC<SvglogoutProps> = (props) => (
  <svg
    {...props}
    height="24"
    width="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 1.40625V11.4072M7 4.9066C5.39456 5.97939 4.17664 7.5401 3.52614 9.35823C2.87564 11.1764 2.82704 13.1555 3.38751 15.0034C3.94799 16.8513 5.08782 18.4699 6.63867 19.6202C8.18953 20.7705 10.0692 21.3915 12 21.3915C13.9308 21.3915 15.8105 20.7705 17.3613 19.6202C18.9122 18.4699 20.052 16.8513 20.6125 15.0034C21.173 13.1555 21.1244 11.1764 20.4739 9.35823C19.8234 7.5401 18.6054 5.97939 17 4.9066"
      stroke="#5F6D7E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity="0.8"
      strokeWidth="2"
    />
  </svg>
);

export default Svglogout;
